export const orderStatus = [
  { value: 1, label: "Pendiente", key: "pendiente" },
  { value: 2, label: "Terminado", key: "terminado" },
  { value: 3, label: "Lista para facturar", key: "listoParaFacturar" },
  { value: 4, label: "Facturada", key: "facturada" },
  { value: 5, label: "Pagado", key: "pagado" },
  {
    value: 6,
    label: "Solicitud de cancelación",
    key: "solicitudDeCancelación",
  },
  { value: 7, label: "Cancelado", key: "cancelado" },
];

export const mainOrderStatus = [
  { value: 1, label: "Pendiente" },
  { value: 2, label: "Terminado" },
  { value: 3, label: "Lista para facturar" },
  { value: 7, label: "Cancelado" },
];

/**
 * Estados que el sistema realmente escribe hoy:
 *   1 Pendiente / 2 Terminado  → los pone el operador al guardar la orden
 *                                (Terminado exige firma Y fotos).
 *   3 Lista para facturar / 7 Cancelado → los elige el admin en el detalle.
 *   4 Facturada → se pone sola al emitir la factura desde Órdenes por cliente.
 *
 * 5 (Pagado) y 6 (Solicitud de cancelación) están definidos pero ningún flujo
 * los asigna: el pago se registra sobre la FACTURA, no sobre la orden. Se
 * mantienen en `orderStatus` para que una fila vieja siga mostrando su etiqueta,
 * pero no se ofrecen como filtro ni cuentan en los gráficos.
 */
export const writableOrderStatusValues = [1, 2, 3, 4, 7];

export const selectableOrderStatus = orderStatus.filter((status) =>
  writableOrderStatusValues.includes(status.value)
);

export const orderObjectStatus = {
  pendiente: 1,
  terminado: 2,
  listoParaFacturar: 3,
  facturada: 4,
  pagado: 5,
  solicitudDeCancelación: 6,
  cancelado: 7,
};

/** Estados que los operadores no pueden ver (Terminada / finalizada en el flujo de trabajo). */
export const operatorHiddenOrderStatuses = [
  orderObjectStatus.terminado,
  orderObjectStatus.listoParaFacturar,
  orderObjectStatus.facturada,
  orderObjectStatus.pagado,
  orderObjectStatus.solicitudDeCancelación,
  orderObjectStatus.cancelado,
];

export const isOrderVisibleToOperator = (status) =>
  !operatorHiddenOrderStatuses.includes(status);
